// dna_frontend/src/components/Sidebar.js
// (*** ĐÃ CẬP NHẬT ĐẦY ĐỦ: Thêm menu Rà soát LS Dòng Nội ***)

import React from 'react';
import { useNavigate, Link as RouterLink, useLocation } from 'react-router-dom';
import { styled, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
// import Toolbar from '@mui/material/Toolbar'; 
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Button from '@mui/material/Button'; 

// Import Icons
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import ScienceIcon from '@mui/icons-material/Science';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import LockResetIcon from '@mui/icons-material/LockReset';
import LogoutIcon from '@mui/icons-material/Logout';
import AssessmentIcon from '@mui/icons-material/Assessment'; 
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import TaskIcon from '@mui/icons-material/Task';
import FactCheckIcon from '@mui/icons-material/FactCheck'; 
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch'; 
import FindInPageIcon from '@mui/icons-material/FindInPage';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar, 
  justifyContent: 'flex-end', 
}));

function Sidebar({ open, handleDrawerClose, drawerWidth, variant, onClose }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation(); 
  const user = JSON.parse(localStorage.getItem('user'));
  
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  const menuItems = [
    // --- KHỐI QUẢN TRỊ CHUNG & THỐNG KÊ ---
    { text: 'Dashboard', icon: <DashboardIcon />, path: '/dashboard', roles: ['admin', 'tinh', 'xa'] },
    { text: 'Lịch Thu Mẫu', icon: <CalendarMonthIcon />, path: '/lich-thu-mau', roles: ['admin', 'tinh', 'xa'] },
    
    // --- KHỐI ADMIN QUẢN TRỊ HỆ THỐNG ---
    { text: 'Quản lý User', icon: <PeopleIcon />, path: '/admin/users', roles: ['admin'] },
    { text: 'Quản lý Thân nhân', icon: <RecentActorsIcon />, path: '/admin/than-nhan', roles: ['admin'] },
    { text: 'Duyệt Đề Nghị Xóa', icon: <DeleteSweepIcon />, path: '/admin/duyet-xoa', roles: ['admin'] },
    
    // --- KHỐI QUẢN LÝ NGHIỆP VỤ ---
    { text: 'Quản lý Liệt sĩ', icon: <AssessmentIcon />, path: '/liet-si-management', roles: ['admin', 'xa'] },

    // --- KHỐI UPLOAD (ADMIN) ---
    { text: 'Upload Dữ liệu (Excel)', icon: <UploadFileIcon />, path: '/admin/upload', roles: ['admin'] },
    { text: 'Upload DS Đã Thu', icon: <CloudUploadIcon />, path: '/admin/upload-thu-mau', roles: ['admin'] },
    
    { text: 'Theo dõi Hằng ngày', icon: <AssessmentIcon />, path: '/bao-cao', roles: ['admin'] },
    
    // --- KHỐI TÁC VỤ CỦA XÃ ---
    { text: 'Rà soát (Xã)', icon: <AssignmentIndIcon />, path: '/xa/ra-soat', roles: ['admin', 'xa'] },
    
    // --- KHỐI TÁC VỤ CỦA TỈNH ---
    { text: 'Thu mẫu (Tỉnh)', icon: <ScienceIcon />, path: '/tinh/thu-mau', roles: ['admin', 'tinh'] },
    
    // --- KHỐI TRA CỨU & CÁ NHÂN ---
    { text: 'Tìm kiếm / Xuất file', icon: <ManageSearchIcon />, path: '/search-export', roles: ['admin', 'tinh', 'xa'] },
    { text: 'Đổi mật khẩu', icon: <LockResetIcon />, path: '/change-password', roles: ['admin', 'tinh', 'xa'] },
  ];

  const visibleMenuItems = menuItems.filter(item => item.roles.includes(user?.role));

  return (
    <> 
      <CssBaseline />
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            background: '#343a40', 
            color: '#adb5bd', 
          },
        }}
        variant={isMobile ? 'temporary' : (variant || 'permanent')} 
        anchor="left"
        open={open} 
        onClose={isMobile ? onClose : handleDrawerClose}
        ModalProps={{
          keepMounted: true, 
        }}
      >
        <DrawerHeader sx={{ background: '#212529', justifyContent: 'space-between' }}> 
           <Typography variant="h6" noWrap component="div" sx={{ color: 'white', paddingLeft: '16px' }}>
             Dự án ADN NA
           </Typography>
          <IconButton onClick={handleDrawerClose} sx={{ color: 'white' }}>
            {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </DrawerHeader>
        <Divider sx={{ borderColor: '#4f5962' }} />
        
        <List>
          {visibleMenuItems.map((item) => (
            <ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
              <ListItemButton 
                component={RouterLink} 
                to={item.path}
                selected={location.pathname === item.path} 
                sx={{ 
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center', 
                  px: 2.5, 
                  '&:hover': { backgroundColor: '#495057', color: 'white' },
                  '&.Mui-selected': { 
                    backgroundColor: '#007bff', color: 'white',
                    '&:hover': { backgroundColor: '#0056b3' },
                    '& .MuiListItemIcon-root': { color: 'white' }
                  }
                }}
              >
                <ListItemIcon sx={{ 
                    color: location.pathname === item.path ? 'white' : '#adb5bd', 
                    minWidth: 0,
                    mr: open ? 3 : 'auto', 
                    justifyContent: 'center',
                 }}> 
                  {item.icon}
                </ListItemIcon>
                <ListItemText primary={item.text} sx={{ opacity: open ? 1 : 0 }} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
        <Divider sx={{ borderColor: '#4f5962', marginTop: 'auto' }} />
        
        {open && (
           <Box sx={{ p: 2, mt: 'auto', textAlign: 'center' }}>
              <Typography variant="body2">User: <strong>{user?.username}</strong> ({user?.role})</Typography>
              <Button 
                 variant="contained" color="error" startIcon={<LogoutIcon />} 
                 onClick={handleLogout} fullWidth sx={{ mt: 2 }}
               >
                 Đăng xuất
              </Button>
           </Box>
        )}
         {!open && (
             <Box sx={{ p: 1, mt: 'auto', textAlign: 'center' }}>
                 <IconButton onClick={handleLogout} sx={{ color: '#adb5bd' }} title="Đăng xuất">
                     <LogoutIcon />
                 </IconButton>
             </Box>
         )}
      </Drawer>
    </> 
  );
}

export default Sidebar;